import React, {useContext, useEffect, useState} from 'react';
import Tree from 'react-animated-tree'
import Api from "../../../../interface/api/site";
import {HostStateContext} from "../../index";
import {SiteInfo, SiteVisitPurposeInfo, SiteVisitPurposeGroupInfo} from "../../../../interface/model/site";

import { AiOutlineFile, AiOutlineFolder } from "react-icons/ai";
import { DiAptana } from "react-icons/di";
import { FiPlus, FiEdit2, FiTrash2, FiSliders, FiTag } from "react-icons/fi";
import { VscGroupByRefType } from "react-icons/vsc";
import {ManagementMenuOptionItem, ManagementMenuOptionItem2} from "../../../../component/menu-item";
interface IData {
    seq : number, name : string
}
interface ModalFlag {
    openFlag: boolean,
    data : IData | null
}
export default function PositionManage() {
    const { hostInfo } = useContext(HostStateContext);
    const [ siteInfo, setSiteInfo ] = useState<SiteInfo>();
    const [ modal, setModal ] = useState<ModalFlag>({openFlag: false, data : null});
    const [ groupModal, setGroupModal ] = useState<ModalFlag>({openFlag: false, data : null});

    function closeModalHandler(flag) {
        // Api.siteInfoListBySeq(hostInfo.siteInfo.seq).then(res => {
        //     setSiteInfo(res.data);
        //     // setModal({openFlag: flag, data : null});
        // });
        setGroupModal({openFlag: flag, data : null});
        setModal({openFlag: flag, data : null});
    }

    useEffect(() => {
        Api.siteInfoListBySeq(hostInfo.siteInfo.seq).then(res => {
            setSiteInfo(res.data);
        });
    }, [])

    return (
        <>
        <div className="build_container">
            <SiteLocation hostInfo={hostInfo} setModal={setModal} />
            <SiteVisitPurpose hostInfo={hostInfo}
                              setModal={setModal}/>
            <SiteVisitPurposeGroup hostInfo={hostInfo} setGroupModal={setGroupModal}/>
        </div>
            {
                modal.openFlag &&
                <SubItemAddModal
                    modal={modal}
                    closeModalHandler={closeModalHandler}
                />
            }
            {
                groupModal.openFlag &&
                    <GroupModal modal={groupModal}
                                hostInfo={hostInfo}
                                closeModalHandler={closeModalHandler} />
            }
        </>
    )
}
function SiteLocation({hostInfo, setModal}) {
    const [ siteInfo, setSiteInfo ] = useState<SiteInfo>();

    function createSiteInfo(data : IData) {
        Api.createSiteInfo(data.seq, data.name).then(res => window.location.reload());

    }

    function updateSiteInfo(data : IData) {
        Api.updateSiteInfo(data.seq, data.name).then(res => window.location.reload());
    }

    function deleteSiteInfo(data : IData) {
        if(window.confirm(`'${data.name}'을(를) 삭제 하시겠습니까?\n*주의 : 하위 항목이 존재할 경우 함께 삭제됩니다.`)) {
            Api.deleteSiteInfo(data.seq).then(res => window.location.reload());
        }
    }

    function onActionHandler(callback , data) {
        setModal(
            {
                openFlag: true
                , data : data
                , callback : callback
            });
        return null;
    }

    useEffect(() => {
        Api.siteInfoListBySeq(hostInfo.siteInfo.seq).then(res => {
            setSiteInfo(res.data);
        });
    }, [])


    return (
        <section>
            <div className="edit_btn_area">
                <button type="button" className="btn_plus nv_modal1_open" style={{background: 'none', cursor: 'auto'}}>
                    방문 위치
                </button>
            </div>
            <div className="list hover site_list" style={{padding: '0 20px', fontSize:'1.2em'}}>
                {
                    siteInfo!== undefined &&
                    <Tree content={ siteInfo.parentSiteInfo !== null ? siteInfo.parentSiteInfo.name : '건물정보' } open>
                        <Tree type = {
                            <span>{siteInfo.name}</span>
                        } content = {
                            siteInfo.parentSiteInfo !== null ?
                                <div style={{
                                    position: 'absolute',
                                    left: '73%',
                                    top: '5px'
                                }}>
                                    <ManagementMenuOptionItem items={[
                                        {
                                            innerHTML:'항목 수정',
                                            onClickHandler:() => onActionHandler(updateSiteInfo, {seq : siteInfo.seq, name : siteInfo.name})
                                        },
                                        {
                                            innerHTML:'항목 제거',
                                            onClickHandler:() => deleteSiteInfo({seq : siteInfo.seq, name : siteInfo.name})
                                        },
                                        {
                                            innerHTML:'하위 항목 추가',
                                            onClickHandler:() => onActionHandler(createSiteInfo, {seq : siteInfo.seq, name : ''})
                                        }
                                    ]}/>
                                </div>
                                :
                                <div style = {{
                                    position: 'absolute',
                                    left: '73%',
                                    top: '5px'
                                }}>
                                    <ManagementMenuOptionItem items={[
                                        {
                                            innerHTML:'하위 항목 추가',
                                            onClickHandler:() => onActionHandler(createSiteInfo, {seq : siteInfo.seq, name : ''})
                                        }
                                    ]}/>
                                </div>
                        } open>
                            {
                                siteInfo.childrenSiteInfos.map((row, index) => (
                                    <Tree type = {
                                        <span>{row.name}</span>
                                    } content={
                                        <div style={{
                                            position: 'absolute',
                                            left: '72%',
                                            top: '5px'
                                        }}>
                                            <ManagementMenuOptionItem items={[
                                                {
                                                    innerHTML:'항목 수정',
                                                    onClickHandler:() => onActionHandler(updateSiteInfo, {seq : row.seq, name : row.name})
                                                },
                                                {
                                                    innerHTML:'항목 제거',
                                                    onClickHandler:() => deleteSiteInfo({seq : row.seq, name : row.name})
                                                },
                                                {
                                                    innerHTML:'하위 항목 추가',
                                                    onClickHandler:() => onActionHandler(createSiteInfo, {seq : row.seq, name : ''})
                                                }
                                            ]}/>
                                        </div>
                                    } key={`siteInfo3DepthKey-${row.sort}-${index}`} open>
                                        {
                                            row.childrenSiteInfos.map((row2, index2) => (
                                                <Tree type={
                                                    <span>{row2.name}</span>
                                                } content={
                                                    <div style={{
                                                        position: 'absolute',
                                                        left: '70%',
                                                        top: '5px'
                                                    }}>
                                                        <ManagementMenuOptionItem items={
                                                            [
                                                                {
                                                                    innerHTML:'항목 수정',
                                                                    onClickHandler:() => onActionHandler(updateSiteInfo, {seq : row2.seq, name : row2.name})
                                                                },
                                                                {
                                                                    innerHTML:'항목 제거',
                                                                    onClickHandler:() => deleteSiteInfo({seq : row2.seq, name : row2.name})
                                                                },
                                                            ]
                                                        }/>
                                                    </div>
                                                } key={`siteInfo4DepthKey-${row2.sort}-${index}`} open>
                                                </Tree>
                                            ))
                                        }
                                    </Tree>
                                ))
                            }
                        </Tree>
                    </Tree>
                }
            </div>
        </section>
    )
}
function SiteVisitPurpose({hostInfo, setModal}) {
    const [ siteVisitPurposeInfos, setSiteVisitPurposeInfos ] = useState<Array<SiteVisitPurposeInfo>>([]);

    function createSiteVisitPurposeInfo(data : IData) {
        Api.createSiteVisitPurposeInfo(data.seq, data.name).then(res => window.location.reload());

    }

    function updateSiteVisitPurposeInfo(data : IData) {
        Api.updateSiteVisitPurposeInfo(data.seq, data.name).then(res => window.location.reload());
    }

    function deleteSiteVisitPurposeInfo(data : IData) {
        if(window.confirm(`'${data.name}'을(를) 삭제 하시겠습니까?`)) {
            Api.deleteSiteVisitPurposeInfo(data.seq).then(res => window.location.reload());
        }
    }

    function onActionHandler(callback , data) {
        setModal(
            {
                openFlag: true
                , data : data
                , callback : callback
            });
        return null;
    }

    useEffect(() => {
        Api.getSiteVisitPurposeInfo(hostInfo.siteInfo.seq).then(res => {
            setSiteVisitPurposeInfos(res.data);
        });
    }, [])
    return (
        <section>
            <div className="edit_btn_area">
                <button type="button" className="btn_plus nv_modal1_open" style={{background: 'none', cursor: 'auto'}}>
                    방문 목적
                </button>
            </div>
            <div className="list hover site_list" style={{padding: '0 20px', fontSize:'1.2em'}}>
                <Tree type = {
                    <span>{hostInfo.siteInfo.name}</span>
                } content = {
                    <div style = {{
                        position: 'absolute',
                        left: '40%',
                        top: '4px'
                    }}>
                        <ManagementMenuOptionItem items={[
                            {
                                innerHTML:'하위 항목 추가',
                                onClickHandler:() => onActionHandler(createSiteVisitPurposeInfo, {seq : hostInfo.siteInfo.seq, name : ''})
                            }
                        ]}/>
                    </div>
                } open >
                    {
                        siteVisitPurposeInfos.map((visitPurposeInfo, index) => (
                            <Tree type = {
                                <span>
                                            {visitPurposeInfo.name}
                                        </span>
                            } content={
                                <div style={{
                                    position: 'absolute',
                                    left: '40%',
                                    top: '4px'
                                }}>
                                    <ManagementMenuOptionItem items={[
                                        {
                                            innerHTML:'항목 수정',
                                            onClickHandler:() => onActionHandler(updateSiteVisitPurposeInfo, {seq : visitPurposeInfo.seq, name : visitPurposeInfo.name})
                                        },
                                        {
                                            innerHTML:'항목 제거',
                                            onClickHandler:() => deleteSiteVisitPurposeInfo({seq : visitPurposeInfo.seq, name : visitPurposeInfo.name})
                                        }
                                    ]}/>
                                </div>
                            } key={`visitPurposeInfo-${index}`} open />
                        ))
                    }
                </Tree>

            </div>
        </section>
    )
}
function SiteVisitPurposeGroup({hostInfo, setGroupModal}) {

    const [ siteVisitPurposeGroupInfos, setSiteVisitPurposeGroupInfos ] = useState<Array<SiteVisitPurposeGroupInfo>>([]);

    function createSiteVisitPurposeGroupInfo(data) {
        Api.createSiteVisitPurposeGroupInfo(hostInfo.siteInfo.seq, data.name).then(res => window.location.reload());
    }

    function updateSiteVisitPurposeGroupInfo(data) {
        Api.updateSiteVisitPurposeGroupInfo(data.seq, data.name, data.siteVisitPurposeInfos).then(res => window.location.reload());
    }

    function deleteSiteVisitPurposeGroupInfo(data) {
        if(window.confirm(`'${data.name}'을(를) 삭제 하시겠습니까?`)) {
            Api.deleteSiteVisitPurposeGroupInfo(data.seq).then(res => window.location.reload());
        }
    }

    function onActionHandler(callback , data) {
        setGroupModal({
                openFlag: true
                , data : data
                , callback : callback
            });
        return null;
    }

    useEffect(() => {
        Api.getSiteVisitPurposeGroupInfo(hostInfo.siteInfo.seq).then(res => {
            setSiteVisitPurposeGroupInfos(res.data);
        });
    }, [])

    return (
        <section>
            <div className="edit_btn_area">
                <button type="button" className="btn_plus nv_modal1_open" style={{background: 'none', cursor: 'auto'}}>
                    방문 목적 그룹
                </button>
            </div>
            <div className="list hover site_list" style={{padding: '0 20px', fontSize:'1.2em'}}>
                <Tree type = {
                    <span>{hostInfo.siteInfo.name}</span>
                } content = {
                    <div style = {{
                        position: 'absolute',
                        left: '40%',
                        top: '4px'
                    }}>
                        <ManagementMenuOptionItem items={[
                            {
                                innerHTML:'하위 항목 추가',
                                onClickHandler:() => onActionHandler(createSiteVisitPurposeGroupInfo, {name : ''})
                            }
                        ]}/>
                    </div>
                } open >
                    {
                        siteVisitPurposeGroupInfos.map((visitPurposeGroupInfo, index) => (
                            <Tree type = {
                                <span>
                                            {visitPurposeGroupInfo.name}
                                        </span>
                            } content={
                                <div style={{
                                    position: 'absolute',
                                    left: '40%',
                                    top: '4px'
                                }}>
                                    <ManagementMenuOptionItem items={[
                                        {
                                            innerHTML:'항목 수정',
                                            onClickHandler:() => onActionHandler(updateSiteVisitPurposeGroupInfo, {seq : visitPurposeGroupInfo.seq, name : visitPurposeGroupInfo.name})
                                        },
                                        {
                                            innerHTML:'항목 제거',
                                            onClickHandler:() => deleteSiteVisitPurposeGroupInfo({seq : visitPurposeGroupInfo.seq, name : visitPurposeGroupInfo.name})
                                        }
                                    ]}/>
                                </div>
                            } key={`visitPurposeInfo-${index}`} open >
                                {
                                    visitPurposeGroupInfo.siteVisitPurposeInfos.map((row, index) => (
                                        <Tree type = {
                                            <span>{row.name}</span>
                                        } key={`siteInfo3DepthKey-${row.seq}-${index}`} open/>
                                    ))
                                }
                            </Tree>
                        ))
                    }
                </Tree>

            </div>
        </section>
    )
}
function SubItemAddModal({modal, closeModalHandler}) {

    const [ data, setData ] = useState<IData>(modal.data);

    return (
        <div className="nv_modal on">
            <div className="nv_modal_container">
                <div className="nv_modal_header">
                    <h2 id="sub_item_title">항목 관리</h2>
                    <p className="nv_modal_close" onClick={() => closeModalHandler(false)}>닫기</p>
                </div>
                <div className="nv_modal_contents">
                    <>
                        <table className="nv_table textcenter" id="sub_item_table">
                            <tbody>
                            <tr>
                                <th>항목 명</th>
                                <td>
                                    <input className="nv_input"
                                           value={data.name}
                                           onChange={(e) => setData({...data, name : e.target.value})} />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <button className="nv_blue_button m_full_btn" style={{float:'right', marginBottom:'10px'}}
                                onClick={() => modal.callback(data)}
                        >확인</button>
                    </>
                </div>
            </div>
        </div>
    )
}
function GroupModal({modal, hostInfo, closeModalHandler}) {
    const [ data, setData ] = useState<IData>(modal.data);
    const [ siteVisitPurposeInfos, setSiteVisitPurposeInfos ] = useState<Array<SiteVisitPurposeInfo>>([]);
    const [ selectedSiteVisitPurposeInfos, setSelectedSiteVisitPurposeInfos ] = useState<Array<number>>([]);

    function selectedHandler(e) {
        let value = Number(e.target.value);
        if(e.target.checked)
            setSelectedSiteVisitPurposeInfos(selectedSiteVisitPurposeInfos.concat(value))
        else
            setSelectedSiteVisitPurposeInfos(selectedSiteVisitPurposeInfos.filter(row => row!==value));

    }

    useEffect(() => {
        Api.getSiteVisitPurposeInfo(hostInfo.siteInfo.seq).then(res => {
            setSiteVisitPurposeInfos(res.data);
        });
    }, [])

    return (
        <div className="nv_modal on">
            <div className="nv_modal_container">
                <div className="nv_modal_header">
                    <h2 id="sub_item_title">항목 관리</h2>
                    <p className="nv_modal_close" onClick={() => closeModalHandler(false)}>닫기</p>
                </div>
                <div className="nv_modal_contents">
                    <>
                        <table className="nv_table textcenter" id="sub_item_table" style={{textAlign:'left'}}>
                            <colgroup>
                                <col width="80"/><col/>
                            </colgroup>
                            <tbody>
                            <tr>
                                <th>항목 명</th>
                                <td>
                                    <input className="nv_input"
                                           value={data.name}
                                           onChange={(e) => setData({...data, name : e.target.value})}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>그룹 지정</th>
                                <td className="nv_gray_check">
                                    <ul>
                                        {
                                            siteVisitPurposeInfos.map((row, index) =>
                                                <li key={`groupcheckboxIndex${index}`} style={{width:'45%'}}>
                                                    <input type="checkbox"
                                                           id={`checkbox-${index}`}
                                                           value={row.seq}
                                                           // checked={selectedSecretaryHostInfo!==undefined && selectedSecretaryHostInfo.number == row.number}
                                                           onClick={(e) => (selectedHandler(e))}
                                                    />
                                                    <label htmlFor={`checkbox-${index}`}>{row.name}</label>
                                                    {row.name}
                                                </li>
                                            )
                                        }
                                    </ul>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <button className="nv_blue_button m_full_btn" style={{float:'right', marginBottom:'10px'}}
                                onClick={() => modal.callback({...data, siteVisitPurposeInfos : selectedSiteVisitPurposeInfos})}
                        >확인</button>
                    </>
                </div>
            </div>
        </div>
    )
}